import axios, { AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ResetPasswordRequest } from '../../../../models/authentication/ResetPasswordRequest';

export function useChangePassword(
    options?: UseMutationOptions<AxiosResponse, Error, ResetPasswordRequest>
) {
    return useMutation({
        mutationFn: async (request: ResetPasswordRequest) =>
            axios.put('/v1/citizen/password/change', request),
        ...options
    });
}
